<template>
    <el-container>
        <el-main>
            <el-dialog title="关联用户" :visible.sync="linkUser" width="30%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="formData"  :model="formData" :rules="rules"  label-width="80px"  class="demo-ruleForm">
                    <el-form-item label="手机号" prop="phone">
                        <el-autocomplete
                                v-model="formData.phone"
                                :fetch-suggestions="querySearchAsync"
                                placeholder="手机号"
                                @select="handleSelect"
                                style="width: 70%"
                        >
                            <i
                                    slot="suffix"
                                    @click="handleIconClick">
                            </i>
                            <template slot-scope="props">
                                <div class="name">{{ props.item.phone }}</div>
                                <span class="phone">{{ props.item.userName }}</span>
                            </template>
                        </el-autocomplete>
                    </el-form-item>
                    <el-form-item label="机构" prop="orgCode">
                        <el-select v-model="formData.orgCode" placeholder="机构"  size="small" style="width: 70%">
                            <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户名" prop="userName">
                        <el-input v-model="formData.userName"  placeholder="用户名" style="width: 70%" :disabled="true"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="saveUserOrg('formData')">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="添加角色" :visible.sync="showRole" width="30%" :close-on-click-modal=false>
                <el-transfer
                        v-model="selectedRoles"
                        :props="{key:'roleId',label: 'roleName'}"
                        :left-default-checked="leftChecked"
                        :right-default-checked="rightChecked"
                        filterable
                        :titles="['待选角色', '已选角色']"
                        :data="roleData">
                </el-transfer>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showRole = false">取 消</el-button>
                    <el-button type="primary" @click="saveRole()">确 定</el-button>
                </div>
            </el-dialog>


            <el-form ref="searchDate" :model="searchData"  label-position="top">
                <el-row >
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="用户名" prop="userName" style="width: 70%">
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="手机号" prop="phone" style="width: 70%">
                            <el-input v-model="searchData.phone" placeholder="手机号" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="cls-col">
                        <el-form-item label="机构" prop="orgCode">
                            <el-select v-model="searchData.orgCode" clearable placeholder="机构" size="small" style="width: 70%;">
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
            </el-form>


            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="linkUser = true" class="but-cls">关联用户</el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteMore" class="but-cls">删除</el-button>
            <el-table
                    :data="userOrgData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="userName"
                        label="用户名"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="orgName"
                        label="机构"
                >
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号"
                        width="200"
                >
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <el-button @click="selectRole(scope.$index, scope.row)"  size="small" type="text">角色管理</el-button>
                        <el-button @click="deleteUserOrg(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import validate from '@/api/validate.js'
    const formData = {
        accountId:"",
        orgCode: "",
        orgName: "",
        userId: "",
        userName: "",
        phone: "",
        realName: "",
        status: 1,
    };
    export default {
        name: "",
        data() {
            return {
                userOrgData: [],
                formData: JSON.parse(JSON.stringify(formData)),
                searchData: {
                    orgCode: "",
                    phone: "",
                    realName: "",
                    status: "",
                    type: "",
                    userId: "",
                    userName: "",
                    page: "1",
                    size: "",
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入电话', trigger: 'blur' },
                        {validator: validate.validatePhone, trigger: 'blur'}
                    ],
                    userName: [
                        { required: true, message: '没有匹配用户信息', trigger: 'blur' }
                    ],
                },
                leftChecked: [],
                rightChecked: [],
                loading: false,
                total: 0,
                linkUser: false,
                showRole: false,
                pageSize: 10,
                multipleSelection: [],
                accountId: "",
                restaurants: [],
                timeout:  null,
                roleData: [],
                selectedRoles: [],
                currentPage: 1,
                org: [],
            }
        },
        methods: {
            handleDialogClose() {
                this.linkUser = false;
                this.formData = JSON.parse(JSON.stringify(formData));
            },
            searchUser(queryString) {
                let params = {
                    search: ""
                };
                https.fetchGet('/managerAccount/findAccountList',JSON.parse(JSON.stringify(params)),"form" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.restaurants = data.data.data;
                    }
                }).catch(err=>{
                        console.log(err)
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                )
            },
            querySearchAsync(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                if(queryString.length == 11 && results.length == 1) {
                    let item = results[0];
                    this.formData.userName = item.userName;
                    this.formData.userId = item.userId;
                    this.formData.phone = item.phone;
                    this.$refs.formData.clearValidate();
                } else {
                    this.formData.userName = "";
                    this.formData.userId = "";
                }
                cb(results);


            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.phone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.formData.userName = item.userName;
                this.formData.userId = item.userId;
                this.formData.phone = item.phone;
                this.$refs.formData.clearValidate();
            },
            handleIconClick(ev) {
                console.log(ev);
            },
            handleSizeChange() {},
            handleCurrentChange(val) {
                this.search(val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].accountId;
                }
            },
            formatStatus(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return "启用";
                }else if(cellValue == 2) {
                    return "停用"
                } else {
                    return "其他";
                }
            },
            selectRole(index, row) {
                let params = {
                    orgCode: row.orgCode,
                    userId: row.userId,
                }
                this.accountId = row.accountId;
                this.selectedRoles = [];
                https.fetchGet('/managerAccount/getAccountRole',JSON.parse(JSON.stringify(params))  , "form").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    let right = [];
                    if(code == '200') {
                        for(let index in data.data.data) {
                            right.push(data.data.data[index].roleId);
                        }
                        this.selectedRoles = right;
                        this.showRole = true;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '请求错误:'+msg
                        });
                    }
                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                )
            },
            deleteMore() {
                let roleLength = this.multipleSelection.length;
                this.$confirm('此操作将删除'+roleLength+'条角色信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params = {
                      accountIdList: this.multipleSelection
                    }
                    https.fetchPost('/managerAccount/deleteByAccountIdList',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络错误');
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteUserOrg(index, row) {
                this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params ={
                      accountIdList: [row.accountId]
                    };
                    https.fetchPost('/managerAccount/deleteByAccountIdList',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络错误');
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            saveRole() {
                let params = {
                    accountId: this.accountId,
                    orgCode: "1234",
                    roleIdList: this.selectedRoles,
                };
                https.fetchPost("/managerAccount/updateAccountRole",params ,"json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.showRole = false;
                    } else {
                        this.$message.error('操作失败:'+msg);
                    }

                }).catch(err=>{
                        console.log(err);
                        this.$message.error('网络错误');
                    }
                )
            },
            saveUserOrg(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        let url = "/managerAccount/addAccount";
                        if(this.formData.accountId) {
                            let url = "/managerAccount/updateAccount";
                        }
                        let params = this.formData;
                        https.fetchPost(url,params ,"json").then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.linkUser = false;
                                this.formData = JSON.parse(JSON.stringify(formData));
                                this.search();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                                console.log(err);
                                this.$message.error('网络错误');
                            }
                        )
                    }
                });
            },
            search(val) {
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                this.searchData.size = this.pageSize;
                let params = this.searchData;
                https.fetchGet('/managerAccount/searchAccount',JSON.parse(JSON.stringify(params)) ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.userOrgData = data.data.data.list;
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            searchRole() {
                let params = {
                    orgCode: 1234,
                };
                https.fetchGet('/managerAccount/getRoleAllByOrgCode',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.roleData = data.data.data;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            selectOrg() {
              https.fetchGet('/managerOrganization/getOrganizationList','', 'from' ).then((data) => {
                let code = data.data.code;
                if(code == 200) {
                  this.org = data.data.data;
                } else {
                  this.$message({
                    type: 'info',
                    message: msg
                  });
                }
        
              }).catch(err=>{
                    this.$message.error('网络错误');
                  }
              );
            },

        },
        created: function () {
            this.search();
            this.searchRole();
            this.searchUser();
            this.selectOrg();
        }
    }
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    li {
        line-height: normal;
        padding: 7px;
    }

    .name {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .phone {
        font-size: 12px;
        color: #b4b4b4;
    }

    .highlighted .addr {
        color: #ddd;
    }
    .cls-col {
        margin-right: 20px;
    }
</style>